"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carouselAddButtonStyles = exports.buttonStyles = void 0;
exports.buttonStyles = {
    position: "absolute",
    top: 0,
    right: 0,
    width: "1.5rem",
    height: "1.5rem",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(220, 175, 15, 0.7)",
    borderBottomLeftRadius: "15px",
    border: "1px solid #fff",
    paddingBottom: "0.15rem",
    zIndex: 1,
};
exports.carouselAddButtonStyles = {
    root: exports.buttonStyles,
    icon: { width: "15px", transform: "rotateZ(45deg)", marginLeft: "3px" },
};
//# sourceMappingURL=styles.js.map